import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { useTableStyles } from "@/pages/heat-report/styles/useTableStyles";
import { Box, Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { RefObject } from "react";
import { useElementTableData } from "./hooks/useElementTableData";
import { useElementStyles } from "./styles/useElementStyles";

interface Props {
	gridRef: RefObject<AgGridReact<any>>;
	coloringEnabled: boolean;
	onToggleColoring: (enabled: boolean) => void;
}

export const ElementTable = ({
	gridRef,
	coloringEnabled,
	onToggleColoring,
}: Props) => {
	const commonTableClasses = useTableStyles();
	const localClasses = useElementStyles();
	const {
		state: { elementData },
	} = useHeatReportContext();
	const { columns, rowData, getRowStyle, frameworkComponents, statusBar } =
		useElementTableData({
			elementList: elementData,
			coloringEnabled,
			onToggleColoring,
		});

	const gridHeight = 105 + (rowData?.length ?? 0) * 35 + 2;
	const minHeight = 190;

	return (
		<>
			<Paper className={commonTableClasses.borderAgGridTable} elevation={0}>
				<Box p={0}>
					<div
						className={localClasses.gridWrapper}
						style={{
							height: `${Math.max(gridHeight, minHeight)}px`,
							minWidth: "100%",
						}}
					>
						<AgGridReact
							ref={gridRef}
							rowData={rowData}
							columnDefs={columns}
							suppressRowClickSelection={true}
							suppressPaginationPanel={true}
							suppressContextMenu
							getRowId={(params) => params.data.id}
							getRowStyle={getRowStyle}
							noRowsOverlayComponent={() => "No chemistry data available"}
							components={frameworkComponents}
							statusBar={statusBar}
						/>
					</div>
				</Box>
			</Paper>
		</>
	);
};
